import React from "react";
import styles from "../Login/Login.module.css";
import greenCircle from "../../public/assets/Eo_circle_green_checkmark.svg";

function UpdatedPassword({ navigate }) {
  return (
    <>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <img
          src={greenCircle}
          alt=""
          style={{ height: "75px", width: "75px" }}
        />
      </div>
      <div
        className={styles.title}
        style={{ padding: "0px 26px", textAlign: "center", marginTop: "8px" }}
      >
        Your password has been updated
      </div>

      <div
        className={styles.subTitle}
        style={{ padding: "0px 85px", marginTop: "8px", textAlign: "center" }}
      >
        You can now log in with your updated credentials.
      </div>
      <div className={styles.LoginLink} onClick={() => navigate("/login")}>
        Login
      </div>
    </>
  );
}

export default UpdatedPassword;
